import Backbone from "backbone";
import $ from "jquery";

  var ACCORDION_ACTIVE_CLASS = "Accordion--active";

 export default Backbone.View.extend({
    events: {
      "click .js-Accordion-control": "toggle"
    },

    toggle: function (event) {
      event.stopPropagation();
      this.render();
    },

    render: function () {
      if (this.$el.hasClass(ACCORDION_ACTIVE_CLASS)) {
        $('.js-Accordion').removeClass(ACCORDION_ACTIVE_CLASS);
      }
      else {
        $('.js-Accordion').removeClass(ACCORDION_ACTIVE_CLASS);
        this.$el.addClass(ACCORDION_ACTIVE_CLASS);
      }

      if (this.$(".js-Accordion-icon").length) {
        this.$(".js-Accordion-icon").slice(0, 2).toggleClass("hidden");
      }
    }
  });
